// extracted by mini-css-extract-plugin
module.exports = {"block":"block__cfqvjIVZdzsPH","switch":"switch__l8A8AzpIYbjbm","link_wrapper":"link_wrapper__bLRWv8OM1kjIV","link":"link__NrlQkvzLJXkC5"};